import { Stack } from "@mui/material";
import { BodyTextM, Icons, useTypedTranslation } from "@repo/ui";
import { type FC, type ReactElement } from "react";
import { sortByNullableDate } from "../../functions/dates";
import SingleTransactionRow from "./SingleTransactionRow";

const iconByType = {
    CONTRIB_CLIENT: <Icons.Pig sx={{ width: "2.4rem", height: "2.4rem" }} />,
    LIFE_INSURER: <Icons.Pig sx={{ width: "2.4rem", height: "2.4rem" }} />,
    CONTRIB_EMPLOYER: <Icons.HandMoney sx={{ width: "2rem", height: "2.4rem" }} />,
    CONTRIB_STATE: <Icons.HandMoney sx={{ width: "2rem", height: "2.4rem" }} />,
    LIFE_EMPLOYER: <Icons.HandMoney sx={{ width: "2rem", height: "2.4rem" }} />,
    LIFE_PAY_IN: <Icons.HandMoney sx={{ width: "2rem", height: "2.4rem" }} />,
    LIFE_PAY_OUT: <Icons.HandMoney sx={{ width: "2rem", height: "2.4rem" }} />,
};

export type TransactionsContainerProps = {
    transactions: {
        type?: keyof typeof iconByType;
        amount: number;
        title: string;
        date: Date | undefined;
    }[];
    isIcon: boolean;
};

export const TransactionsContainer: FC<TransactionsContainerProps> = ({ transactions, isIcon }) => {
    const { t } = useTypedTranslation();

    return (
        <>
            {transactions.length > 0 ? (
                <Stack spacing={4}>
                    {sortByNullableDate<TransactionsContainerProps["transactions"][number]>(transactions).map(
                        (transaction) => {
                            const key = crypto.randomUUID();
                            return (
                                <SingleTransactionRow
                                    key={key}
                                    amount={transaction.amount}
                                    title={transaction.title}
                                    date={transaction.date}
                                    icon={
                                        isIcon && transaction.type
                                            ? (iconByType[transaction.type] as ReactElement)
                                            : undefined
                                    }
                                />
                            );
                        },
                    )}
                </Stack>
            ) : (
                <>
                    <BodyTextM>{t("fufi.transactions.noTransactions")}</BodyTextM>
                    <br />
                </>
            )}
        </>
    );
};

export default TransactionsContainer;
